import { Component, Input, OnInit, input } from "@angular/core";

import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from "@angular/material/expansion";
import { getDictionaryItem } from "../../utils/dictionary.domain";
import { MessageCenter, MessageBannerState } from "../../interfaces/messageCenter.interface";
import { DomSanitizer } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-message-center",
    standalone: true,
    imports: [DatePipe, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription],
    templateUrl: "./message-center.component.html",
    styleUrl: "./message-center.component.scss"
})
export class MessageCenterComponent implements OnInit {
    @Input() data: MessageCenter | undefined;
    @Input() state?: MessageBannerState | undefined = MessageBannerState.none;
    @Input() index?: number | undefined = undefined;
    readonly isFixed = input<boolean>(false);

    // how long the message should be shown in ms
    @Input() progressCount: number | undefined = undefined;
    @Input() panelOpenState = false;
    @Input() listState: boolean = false;

    messsageBackground = MessageBannerState.none;
    showMessage: boolean = true;
    sanitizedMessage: string = "";

    messageCenter: string = "message-center";
    messageCenterToggle: string = "message-center-toggle-description";
    messageCenterDescription: string = "message-center-description";
    messageCenterProgress: string = "message-center-progress-bar";

    fixedStyling: string = "";

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        if (this.progressCount !== undefined) {
            setTimeout(() => {
                this.showMessage = false;
            }, this.progressCount);
        }

        if (this.data && this.data.message) {
            const message = this.data.message;
            this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(message) as string;
        }

        if (this.data?.priority) {
            this.state = this.getMessageBannerState(this.data?.priority ?? 922520002);
            if (this.listState !== true) {
                this.messsageBackground = this.state;
            }
        } else this.messsageBackground = this.state ?? MessageBannerState.none;
    }

    getMessageBannerState(state: number): MessageBannerState {
        //if (this.listState === true) return MessageBannerState.none;
        switch (state) {
            case 922520002:
                return MessageBannerState.success;
            case 922520001:
                return MessageBannerState.warning;
            case 922520000:
                return MessageBannerState.error;
            default:
                return MessageBannerState.none;
        }
    }
    getStateText(state: number | undefined): string {
        switch (state) {
            case 922520002:
                return "Lav";
            case 922520001:
                return "Normal";
            case 922520000:
                return "Høj";
            default:
                return "Ingen";
        }
    }
    getDictionaryItem = getDictionaryItem;
}
